import styled, { css, keyframes } from 'styled-components';

export const LogsListWrapper = styled.div`
  ${({ theme: { spacing, color, borderRadius } }) => css`
    background-color: ${color.white};
    display: flex;
    flex-direction: column;
    border: 1px solid ${color.blue30};
    border-radius: ${borderRadius.sm};
    padding: ${spacing.md};
    min-height: 0;
    flex: 1;
  `}
`;

export const LogsList = styled.div`
  ${({ theme: { spacing, color, borderRadius } }) => css`
    gap: ${spacing.sm};
    overflow-y: overlay;
    overflow-y: scroll;
    flex: 1;
    li {
      margin-bottom: 1rem;
    }
    display: flex;
    flex-direction: column;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 60px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 60px;
    }
    @media (hover: hover) {
      /* custom css for devices where the primary input mechanism can hover */
      &::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 0);
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0);
      }
    }
    /* firefox */
    scrollbar-color: ${color.blue30} rgba(0, 0, 0, 0);
    scrollbar-width: thin;
    :hover {
      &::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 0);
      }
      &::-webkit-scrollbar-thumb {
        background-color: ${color.blue30};
      }
    }
  `}
`;
LogsList.displayName = 'LogsList';

export const FinishWrapper = styled.div`
  margin-top: 2rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
`;
FinishWrapper.displayName = 'FinishWrapper';

const bounceAnim = keyframes`
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-8px);
  }
`;

export const LoadingIndicatorWrapper = styled.div`
  display: inline-block;
  border-radius: 0 16px 16px 16px;
  overflow: hidden;
`;

export const ChatBubble = styled.div`
  ${({ $chatType, theme: { font, borderRadius, spacing, color } }) => css`
    max-width: 294px;
    border-radius: ${borderRadius.sm};
    padding: ${spacing.sm} ${spacing.md};
    display: flex;
    ${font.note}
    ${$chatType === 'bot' &&
    css`
      background-color: ${color.midnight10};
      color: ${color.white};
      margin-right: auto;
    `}
  ${$chatType === 'user' &&
    css`
      background-color: ${color.blue40};
      color: ${color.midnight10};
      margin-left: auto;
    `}
  `}
`;

export const LoadingIndicator = styled(ChatBubble)`
  display: flex;
  gap: 2px;
  font-size: 1.6rem;
  > span {
    height: 17px;
    display: inline-block;
    position: relative;
    bottom: 16px;
    animation-duration: 0.4s;
    animation-name: ${bounceAnim};
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
  > span:nth-child(2) {
    animation-delay: 0.1s;
  }
  > span:nth-child(3) {
    animation-delay: 0.2s;
  }
`;
